import React, { useState, useEffect } from "react";
import { keys, forEach, isEmpty, floor, round, includes } from "lodash";
import { Row, Col, Button, Modal, List, Input, Tooltip, Spin, DatePicker } from "antd";
import { CheckCircleOutlined, EditOutlined } from "@ant-design/icons";
import ContentEditable from "react-contenteditable";
import { ReactSVG } from "react-svg";
import moment from "moment";
import { useSelector } from "react-redux";

import InfoLabel from "../../Elements/InfoLabel";
import { DATE_FORMAT_FRONTEND, DATE_FORMAT_QUERY } from "../../../constants";
import { getTranslation } from "../../../utils/helper";

const { Search } = Input;

const formatTime = time => {
  if (!isNaN(time) && time >= 0 && time < 1) {
    let hours = floor(24 * time);
    let mins = round((24 * time - hours) * 60);
    if (mins === 60) {
      mins = 0;
      hours = hours + 1;
    }
    if (hours > 23) {
      mins = 59;
      hours = 23;
    }
    return `${hours}:${String(mins).padStart(2, "0")}`;
  }
  return time;
};

const CsvMapperForm = ({ isFetching, template, data, onComplete, onCancel }) => {
  const user = useSelector(state => state.auth.user);
  const setting = useSelector(state => state.setting) || user.company;

  const showFields = keys(template);
  const firstDataFields = data[0];

  const phone = firstDataFields.phone?.toString();
  if (!isEmpty(phone) && !phone.includes("+")) {
    firstDataFields.phone = "+" + phone;
  }
  if (!isEmpty(firstDataFields.start_time)) {
    firstDataFields.start_time = formatTime(firstDataFields.start_time);
  }
  if (!isEmpty(firstDataFields.end_time)) {
    firstDataFields.end_time = formatTime(firstDataFields.end_time);
  }
  const dataFields = Object.keys(firstDataFields);

  const mapping = showFields.map(item => {
    return matchedField(item);
  });

  const [state, setState] = useState({
    mapping: mapping,
    visible: false,
    item_index: 0,
    searchedHeader: dataFields,
    visibleModal: false,
    contactType: null,
    contact: null,
  });

  const handleAddDefaultHeader = (field, titleField, dataField, index) => {
    if (field === titleField) {
      const translate = getTranslation(setting, "Contacts", titleField);
      if (dataFields.includes(translate)) {
        addDefaultHeader(translate, index);
      } else if (dataFields.includes(dataField)) {
        addDefaultHeader(dataField, index);
      }
    }
  };

  useEffect(() => {
    showFields.forEach((field, index) => {
      if (!isEmpty(state.mapping[index].template)) return;
      handleAddDefaultHeader(field, "Name", "name", index);
      handleAddDefaultHeader(field, "Phone", "phone", index);
      handleAddDefaultHeader(field, "Address", "address", index);
      handleAddDefaultHeader(field, "Lat", "lat", index);
      handleAddDefaultHeader(field, "Lng", "lng", index);
      handleAddDefaultHeader(field, "Start Time", "start_time", index);
      handleAddDefaultHeader(field, "End Time", "end_time", index);
      handleAddDefaultHeader(field, "Duration", "duration", index);
      handleAddDefaultHeader(field, "Notes", "notes", index);
      handleAddDefaultHeader(field, "Types", "types", index);
      handleAddDefaultHeader(field, "Load", "load", index);
    });
  }, []);

  // useEffect(() => {
  //   if (headers.length) {
  //     headers[headers.length - 1].focus();
  //   }
  //   // eslint-disable-next-line
  // }, [state.mapping.length]);

  function matchedField(item) {
    const matched = showFields.includes(item);
    let fields = [];
    let mappingValues = "";
    let mappingHtml = "";
    const field = template[item];
    let fieldTemplate = field.value || "";
    const isMatch = isMappingFieldValue(item);

    if (fieldTemplate) {
      fields = convertTemplateToFields(fieldTemplate);
      forEach(fields, (tmp, index) => {
        if (!isMappingFieldValue(tmp)) {
          fields.splice(index, 1);
          fieldTemplate = fieldTemplate.replace(`[[${tmp}]]`, "");
        }
      });
      mappingHtml = convertTemplateToHtml(fieldTemplate, fields);
      mappingValues = convertHtmlToValues(mappingHtml, fields);
    } else if (matched && isMatch) {
      fieldTemplate = `[[${item}]]`;
      mappingValues = mappingFieldValue(item);
      mappingHtml = htmlMappingField(item);
    }
    return {
      title: getTranslation(setting, "Orders", item),
      code: item,
      required: field.require,
      info: field.info,
      template: fieldTemplate,
      mappingValues,
      mappingHtml,
    };
  }

  function isMappingFieldValue(field) {
    return typeof firstDataFields[field] !== "undefined";
  }

  function mappingFieldValue(item) {
    // return item === 'Completed Date' ? moment(new Date(firstDataFields[item]), 'MM/DD/YYYY h:mm A').format('MM/DD/YYYY h:mm A') : firstDataFields[item];
    return firstDataFields[item];
  }

  function convertTemplateToFields(template) {
    const fields = [];
    const regex = /\[\[(.*?)\]\]/g;
    let m;
    while ((m = regex.exec(template)) !== null) {
      if (m.index === regex.lastIndex) {
        regex.lastIndex++;
      }
      forEach(m, match => {
        const field = match.replace("[[", "").replace("]]", "");
        fields.push(field);
      });
    }

    return fields;
  }

  function convertTemplateToHtml(template, fields) {
    let mappingHtml = template;
    forEach(fields, field => {
      mappingHtml = mappingHtml.replace(`\[\[${field}\]\]`, htmlMappingField(field));
    });
    return mappingHtml;
  }

  function convertHtmlToValues(html, fields) {
    let mappingValues = html;
    forEach(fields, field => {
      const item = htmlMappingField(field);
      const value = mappingFieldValue(field);
      mappingValues = mappingValues.replace(item, value);
    });
    mappingValues = mappingValues.replace(/&nbsp;/gi, " ");
    mappingValues = mappingValues.replace(/<div> <\/div>/gi, "");
    return mappingValues;
  }

  function convertHtmlToTemplate(html) {
    let template = html;
    const regex = /<span[^>]*>(.*?)<a[^>]*><\/a><\/span>/g;
    let m;

    while ((m = regex.exec(html)) !== null) {
      if (m.index === regex.lastIndex) {
        regex.lastIndex++;
      }
      const match = m[0];
      const field = m[1];
      template = template.replace(match, `[[${field}]]`);
    }

    return template;
  }

  function handleChangeMappingDate(value, index) {
    let mappingHtml = value?.format(DATE_FORMAT_QUERY) || "";
    mappingHtml = mappingHtml.replace(/&nbsp;/g, " ");
    mappingHtml = mappingHtml.replace(/<br>/g, " ");
    mappingHtml = mappingHtml.replace(/\s+/g, " ");
    handleChangeMappingField(mappingHtml, index);
  }

  function handleChangeMappingFields(evt, index) {
    let mappingHtml = evt.target.value;
    mappingHtml = mappingHtml.replace(/&nbsp;/g, " ");
    mappingHtml = mappingHtml.replace(/<br>/g, " ");
    mappingHtml = mappingHtml.replace(/\s+/g, " ");
    mappingHtml = mappingHtml.replace(/<div> <\/div>/gi, "");

    handleChangeMappingField(mappingHtml, index);
  }

  function handleChangeMappingFieldsClick(_evt, index) {
    const mapping = state.mapping;
    let mappingHtml = mapping[index].mappingHtml;
    mappingHtml = mappingHtml.replace(/<br>/g, " ");
    mappingHtml = mappingHtml.replace(/&nbsp;/g, " ");
    mappingHtml = mappingHtml.replace(/\s+/g, " ");
    mappingHtml = mappingHtml.replace(/<div> <\/div>/gi, "");
    mappingHtml = mappingHtml.trim() + "&nbsp;";
    mappingHtml = mappingHtml.trim() + " ";
    handleChangeMappingField(mappingHtml, index);
  }

  function handleChangeMappingField(mappingHtml, index) {
    const mapping = state.mapping;
    const field = mapping[index];
    field.template = convertHtmlToTemplate(mappingHtml);
    const fields = convertTemplateToFields(field.template);
    field.mappingHtml = mappingHtml;
    field.mappingValues = convertHtmlToValues(field.mappingHtml, fields);
    mapping[index] = field;
    setState({ ...state, mapping, visible: false });
  }

  function handleAddHeader(item) {
    const mapping = state.mapping;
    const field = mapping[state.item_index];
    const mappingHtml = (mapping[state.item_index].mappingHtml + " " + htmlMappingField(item)).trim();

    field.template = convertHtmlToTemplate(mappingHtml);
    const fields = convertTemplateToFields(field.template);
    field.mappingHtml = mappingHtml;
    field.mappingValues = convertHtmlToValues(field.mappingHtml, fields);
    if (includes(["Start Time", "End Time"], field.title)) {
      field.mappingValues = formatTime(field.mappingValues);
    }
    if (includes(["Phone"], field.title)) {
      if (!isEmpty(field.mappingValues) && !field.mappingValues.includes("+")) {
        field.mappingValues = "+" + field.mappingValues;
      }
    }

    mapping[state.item_index] = field;
    setState({ ...state, mapping });
  }

  function addDefaultHeader(item, index) {
    const mapping = state.mapping;
    const field = mapping[index];
    const mappingHtml = (mapping[index].mappingHtml + " " + htmlMappingField(item)).trim();

    field.template = convertHtmlToTemplate(mappingHtml);
    const fields = convertTemplateToFields(field.template);
    field.mappingHtml = mappingHtml;
    field.mappingValues = convertHtmlToValues(field.mappingHtml, fields);

    mapping[index] = field;
    setState({ ...state, mapping, visible: false });
  }

  function htmlMappingField(item) {
    return `<span class="MappingField" contenteditable="false">${item}<a class="btnDelete" onclick="var parent = this.parentNode.parentNode; this.parentNode.remove(); parent.blur();"></a></span>`;
  }

  function handleAddRowHeader() {
    const mapping = state.mapping;
    mapping.push({
      title: "",
      required: false,
      template: "",
      mappingValues: "",
      mappingHtml: "",
      matched: false,
      moreField: true,
      errors: {},
    });
    setState({ ...state, mapping });
  }

  function handleOpenSearchFields(index) {
    setState({ ...state, visible: true, item_index: index });
  }

  function handleCancel() {
    setState({ ...state, visible: false });
  }

  function handleCancelMapping() {
    onCancel();
  }

  async function handleDoneMapping() {
    const template = {};
    state.mapping
      .filter(s => !s.moreField)
      .map(mapping => {
        template[mapping.code] = {
          value: mapping.template,
          require: mapping.required,
        };
      });

    template["Fields"] = {};
    state.mapping
      .filter(s => s.moreField)
      .map(mapping => {
        template["Fields"][mapping.title] = mapping.template;
      });
    onComplete(template);
  }

  function handleChangeInputName(e, index) {
    const mapping = state.mapping;
    mapping[index].title = e.target.value;
    setState({ ...state, mapping });
  }

  function onSeachHeader(e) {
    const searchedHeader = dataFields.filter(data_field =>
      data_field.toLowerCase().includes(e.target.value.toLowerCase()),
    );
    setState({ ...state, searchedHeader });
  }

  function handleOnClickRemove(index) {
    const mapping = state.mapping;
    mapping.splice(index, 1);
    setState({ ...state, mapping, item_index: 0 });
  }

  const field = state.mapping[state.item_index];
  return (
    <div className="CsvMapperForm">
      <Spin spinning={isFetching}>
        <div className="FormContent">
          <div className="MappingContent">
            {state.mapping.map((item, index) => {
              return (
                <div className="Item" key={`item-${index}`}>
                  <Row gutter={16}>
                    <Col xs={{ span: 24 }} md={{ span: 5 }}>
                      <div className="TitleFields">
                        <div className="number"> {index + 1} </div>
                        <div className="content">
                          {!item.moreField ? (
                            <InfoLabel text={item.title} title={item.info} required={item.required} />
                          ) : (
                            <>
                              <EditOutlined />
                              <Input
                                onChange={e => handleChangeInputName(e, index)}
                                value={item.title}
                                placeholder="Header Name"
                                disable={item.required}
                              />
                            </>
                          )}
                        </div>
                      </div>
                    </Col>
                    <Col xs={{ span: 24 }} md={{ span: 16 }}>
                      <div className="MappingFields">
                        {item.code === "Date" ? (
                          <DatePicker
                            placeholder="Date"
                            format={DATE_FORMAT_FRONTEND}
                            onChange={value => handleChangeMappingDate(value, index)}
                            value={item.mappingValues ? moment(item.mappingValues) : ""}
                          />
                        ) : (
                          <ContentEditable
                            className="NameFields"
                            html={item.mappingHtml}
                            onChange={e => handleChangeMappingFields(e, index)}
                            onClick={e => handleChangeMappingFieldsClick(e, index)}
                          />
                        )}
                        <div className="ValueFields">{item.mappingValues.replace(/undefined/g, "")}</div>
                        {item.code !== "Date" && (
                          <div className="SelectFields" onClick={() => handleOpenSearchFields(index)}>
                            <Tooltip title="Search Header Data">
                              <div>{getTranslation(setting, "Orders", "Add Attribute")}</div>
                            </Tooltip>
                            <ReactSVG className="icon" src="/icons/add-attribute.svg" />
                          </div>
                        )}
                      </div>
                    </Col>
                    <Col xs={{ span: 24 }} md={{ span: 3 }}>
                      <div className="Notify">
                        {item.mappingValues && (
                          <Button type="link" className="btn-matched">
                            <CheckCircleOutlined />
                            {getTranslation(setting, "Orders", "Matched")}
                          </Button>
                        )}
                        {item.moreField && (
                          <Button
                            key="delete"
                            type="link"
                            onClick={() => handleOnClickRemove(index)}
                            className="btn-remove">
                            <ReactSVG className="icon" src="/icons/delete.svg" />
                          </Button>
                        )}
                      </div>
                    </Col>
                  </Row>
                </div>
              );
            })}
          </div>
          <div className="MappingFooter">
            <Button className="btn-add-header" onClick={() => handleAddRowHeader()}>
              {getTranslation(setting, "Orders", "Add Header")}
              <ReactSVG className="icon" src="/icons/add.svg" />
            </Button>
          </div>
        </div>
        <div className="FormFooter">
          <div className="Left"></div>
          <div className="Right">
            <Button key="cancel" className="btn-cancel" onClick={handleCancelMapping}>
              {getTranslation(setting, "Common", "Cancel")}
            </Button>
            <Button key="submit" type="primary" onClick={handleDoneMapping}>
              {getTranslation(setting, "Common", "Done")}
              <ReactSVG className="icon" src="/icons/submit.svg" />
            </Button>
          </div>
        </div>
      </Spin>
      <Modal
        open={state.visible}
        title={getTranslation(setting, "Orders", "Add Attribute")}
        className="SearchHeaderData"
        onCancel={handleCancel}
        footer={null}>
        <div className="ListHeader">
          <Search
            className="mb-3"
            placeholder={getTranslation(setting, "Orders", "Search Header")}
            onChange={e => onSeachHeader(e)}
          />
          <List>
            {state.searchedHeader.map((item, index) => {
              const isFound = field.template.indexOf(`[[${item}]]`);
              return (
                <List.Item key={index}>
                  <div className="content">
                    <div className="left">
                      <b>{item}</b>: {mappingFieldValue(item)}
                    </div>
                    <div className="right">
                      {isFound >= 0 && <Button type="link">{getTranslation(setting, "Orders", "Added")}</Button>}
                      {isFound < 0 && (
                        <Button key="submit" type="primary" onClick={() => handleAddHeader(item)}>
                          {getTranslation(setting, "Orders", "Add")}
                        </Button>
                      )}
                    </div>
                  </div>
                </List.Item>
              );
            })}
          </List>
        </div>
      </Modal>
    </div>
  );
};

export default CsvMapperForm;
